var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.82682 1.3335C9.14016 1.3335 9.40016 1.58683 9.40016 1.90683V14.1002C9.40016 14.4135 9.14682 14.6735 8.82682 14.6735C4.90016 14.6735 2.16016 11.9335 2.16016 8.00683C2.16016 4.08016 4.90682 1.3335 8.82682 1.3335Z",
    fill: "#FF3B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6934 7.69344L11.8001 5.79344C11.6068 5.6001 11.2868 5.6001 11.0934 5.79344C10.9001 5.98677 10.9001 6.30677 11.0934 6.5001L12.1334 7.5401H5.75342C5.48008 7.5401 5.25342 7.76677 5.25342 8.0401C5.25342 8.31344 5.48008 8.5401 5.75342 8.5401H12.1334L11.0934 9.5801C10.9001 9.77344 10.9001 10.0934 11.0934 10.2868C11.1934 10.3868 11.3201 10.4334 11.4468 10.4334C11.5734 10.4334 11.7001 10.3868 11.8001 10.2868L13.6934 8.38677C13.8868 8.2001 13.8868 7.88677 13.6934 7.69344Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.683c677cfbb4c163acc3be9b35fc5531.svg";
export { ForwardRef as ReactComponent };